import RootComponent from './root-component.jsx';

export default RootComponent;
